import { useState, useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
export default function CallToAction() {
  const ref = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section ref={ref} style={{
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(26, 26, 26)",
    fontFamily: 'Inter, "Inter Fallback"',
    paddingTop: "72px",
    paddingBottom: "72px",
    animation: "none 0s ease 0s 1 normal none running",
    position: "relative",
    overflow: "hidden"
  }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Inter:wght@400;600&display=swap');`}</style>

      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/image_f91c94a81c.jpg" alt="" className="w-full h-auto" style={{
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      fontFamily: 'Inter, "Inter Fallback"',
      animation: "none 0s ease 0s 1 normal none running",
      position: "absolute",
      overflow: "clip",
      maxWidth: "100%",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover"
    }} />

      <div style={{
      backgroundColor: "oklab(0.217772 0.00000990927 0.00000436604 / 0.8)",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      color: "rgb(26, 26, 26)",
      fontFamily: 'Inter, "Inter Fallback"',
      animation: "none 0s ease 0s 1 normal none running",
      position: "absolute",
      inset: 0
    }} />

      <div className="page-container">
        <div className={`relative z-10 flex flex-col items-center text-center transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        maxWidth: "760px",
        marginInline: "auto"
      }}>
          <h2 style={{
          color: "rgb(255, 255, 255)",
          fontFamily: '"Playfair Display", "Playfair Display Fallback"',
          fontSize: "36px",
          fontWeight: "700",
          lineHeight: "40px",
          border: "0px solid rgb(255, 255, 255)",
          textAlign: "center",
          animation: "none 0s ease 0s 1 normal none running",
          marginBottom: "16px"
        }}>
            Ihr Renovierungsprojekt beginnt hier
          </h2>

          <p style={{
          color: "oklab(0.999994 0.0000455677 0.0000200868 / 0.8)",
          fontFamily: 'Inter, "Inter Fallback"',
          fontSize: "18px",
          fontWeight: "400",
          lineHeight: "28px",
          border: "0px solid oklab(0.999994 0.0000455677 0.0000200868 / 0.8)",
          textAlign: "center",
          animation: "none 0s ease 0s 1 normal none running",
          marginBottom: "32px"
        }}>
            Kontaktieren Sie uns für eine unverbindliche und kostenlose Beratung. Wir melden uns innerhalb von 24 Stunden.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <Link to="/ContactPage" style={{
            color: "rgb(255, 255, 255)",
            fontFamily: 'Inter, "Inter Fallback"',
            fontSize: "14px",
            fontWeight: "600",
            lineHeight: "20px",
            backgroundImage: "linear-gradient(to right in oklab, rgb(200, 169, 110) 0%, rgb(212, 188, 143) 100%)",
            borderRadius: "9999px",
            border: "0px solid rgb(255, 255, 255)",
            padding: "14px 32px",
            textAlign: "center",
            animation: "none 0s ease 0s 1 normal none running",
            textDecoration: "none",
            display: "inline-block",
            transition: "opacity 0.15s cubic-bezier(0.4,0,0.2,1), transform 0.15s cubic-bezier(0.4,0,0.2,1)"
          }} onMouseEnter={e => {
            (e.currentTarget as HTMLAnchorElement).style.opacity = "0.9";
            (e.currentTarget as HTMLAnchorElement).style.transform = "scale(1.05)";
          }} onMouseLeave={e => {
            (e.currentTarget as HTMLAnchorElement).style.opacity = "1";
            (e.currentTarget as HTMLAnchorElement).style.transform = "scale(1)";
          }}>
              Jetzt Kontakt aufnehmen
            </Link>

            <Link to="tel:017262 74452" style={{
            color: "oklab(0.999994 0.0000455678 0.0000200868 / 0.9)",
            fontFamily: 'Inter, "Inter Fallback"',
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "24px",
            border: "0px solid oklab(0.999994 0.0000455678 0.0000200868 / 0.9)",
            textAlign: "center",
            animation: "none 0s ease 0s 1 normal none running",
            textDecoration: "none",
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            transition: "color 0.15s ease"
          }} onMouseEnter={e => {
            (e.currentTarget as HTMLAnchorElement).style.color = "rgb(255,255,255)";
          }} onMouseLeave={e => {
            (e.currentTarget as HTMLAnchorElement).style.color = "oklab(0.999994 0.0000455678 0.0000200868 / 0.9)";
          }}>
              <span dangerouslySetInnerHTML={{
              __html: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>`
            }} />
              Oder rufen Sie an: Mobil: 0172 62 74 452
            </Link>
          </div>
        </div>
      </div>
    </section>;
}